// Libraries
import React from 'react'

// Components
import SocialButton from './SocialButton'
import {MicrosoftLogo} from '../SignupLogos'

// Types
import {Auth0Connection} from 'js/types'

interface Props {
  handleSocialClick: (connection: Auth0Connection) => void
}

const MicrosoftSocialButton = ({handleSocialClick}: Props): JSX.Element => (
  <SocialButton
    handleClick={() => handleSocialClick(Auth0Connection.Microsoft)}
    className="sign-up--microsoft"
    buttonText="Microsoft"
  >
    <MicrosoftLogo className="social-button--icon" />
  </SocialButton>
)

export default MicrosoftSocialButton
